<span class="notification__blue-text">&#64; {{ 'mentioned' | ppTranslate }}</span>
{{ 'you_in' | ppTranslate }}
<span class="notification__bold">{{ ppLabel }}</span
>:
